webpackJsonp([36488624380039],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Banners = __webpack_require__(11);
	
	var _PageHelpers = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var HistoricNeighborhoodGrid = function HistoricNeighborhoodGrid(_ref) {
	  var data = _ref.data;
	
	  var page = data.mortyPage;
	
	  // Filter out Featured Events page
	  var allPages = data.allOutdoors.edges.filter(function (p) {
	    return p.node.title !== 'Featured Events';
	  });
	
	  // If there are events, add them to the data
	  var gridData = allPages.concat(data.allOutdoors.edges);
	
	  // Force ordering
	  var pageRoutes = ['/live-downtown/historic-neighborhoods/jackson-ward/', '/live-downtown/historic-neighborhoods/arts-district/', '/live-downtown/historic-neighborhoods/shockoe-bottom/', '/live-downtown/historic-neighborhoods/shockoe-slip/', '/live-downtown/historic-neighborhoods/monroe-ward/', '/live-downtown/historic-neighborhoods/court-end/', '/live-downtown/historic-neighborhoods/financial-district/', '/live-downtown/historic-neighborhoods/manchester/', '/live-downtown/historic-neighborhoods/riverfront-district/', '/live-downtown/historic-neighborhoods/city-center/'];
	
	  var orderedPages = [];
	  pageRoutes.forEach(function (route) {
	    var item = gridData.find(function (obj) {
	      return obj.node.route === route;
	    });
	    if (item) {
	      orderedPages.push(item);
	    }
	  });
	
	  // Filter out undefined values
	  var filteredPages = orderedPages.filter(Boolean);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta2.default, { page: page }),
	    _react2.default.createElement(_Banners.ListGridBannerMinor, { page: page, titleWidth: '696' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'pv3 pv4-m pv5-l flex items-center justify-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-100' },
	        filteredPages && filteredPages.map(function (d) {
	          return _react2.default.createElement(_PageHelpers.ListGridItem, { key: d.node.id, page: d.node });
	        })
	      )
	    )
	  );
	};
	
	exports.default = HistoricNeighborhoodGrid;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	var previewQuery = exports.previewQuery = '\nquery OutdoorGrid($id: String!) {\n  mortyPage(id: { eq: $id }) {\n    title\n    route\n    subtitle\n    route\n    metaTitle\n    metaDescription\n    metaKeywords\n  }\n  allOutdoors: allMortyPage(filter: {\n    route: { ne: "/dummy-page" }\n    section: { eq: "Historic Neighborhoods" }\n}) {\n    edges {\n      node {\n        id\n        title\n        route\n        section\n        abstract\n        template\n        abstractPhotoAltText\n        abstractPhotoFocalPointX\n        metaDescription\n        abstractPhotoFocalPointY\n        abstractPhoto {\n          url\n        }\n      }\n    }\n  }\n}\n';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-historic-neighborhood-grid-js-78ab92905cff351648bd.js